<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.25C4.82436 2.25 2.25 4.82436 2.25 8C2.25 11.1756 4.82436 13.75 8 13.75C11.1756 13.75 13.75 11.1756 13.75 8C13.75 7.58579 14.0858 7.25 14.5 7.25C14.9142 7.25 15.25 7.58579 15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75C10.3219 0.75 12.389 1.84231 13.7147 3.53808C13.9698 3.8644 13.9121 4.33576 13.5858 4.59087C13.2594 4.84598 12.7881 4.78825 12.533 4.46192C11.4793 3.11415 9.84077 2.25 8 2.25Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 0.75C13.9142 0.75 14.25 1.08579 14.25 1.5V4.5C14.25 4.91421 13.9142 5.25 13.5 5.25H10.5C10.0858 5.25 9.75 4.91421 9.75 4.5C9.75 4.08579 10.0858 3.75 10.5 3.75H12.75V1.5C12.75 1.08579 13.0858 0.75 13.5 0.75Z" fill="white"/>
    </svg>
</template>

<script>
    export default {
        name: "Resend"
    }
</script>